import { isEmbedded } from '@yes.technology/react-toolkit'

/** Used when config.js has no ecosystem for the current domain. */
const FALLBACK_ECOSYSTEM = 'Yes Ecosystem'

/**
 * Hostname that identifies the ecosystem: the app's own when it runs
 * standalone, or the outermost ancestor's when it runs inside an iframe.
 *
 * `ancestorOrigins` is ordered from the immediate parent to the top window and
 * is unavailable on Firefox, where `document.referrer` (the immediate parent)
 * is the closest approximation available cross-origin.
 */
const getEcosystemHostname = () => {
  if (!isEmbedded()) return window.location.hostname

  const { ancestorOrigins } = window.location
  const topOrigin = ancestorOrigins?.length
    ? ancestorOrigins[ancestorOrigins.length - 1]
    : document.referrer

  try {
    return new URL(topOrigin).hostname
  } catch {
    return window.location.hostname
  }
}

/**
 * Ecosystem name configured in config.js for the current domain, matching both
 * the domain itself and its subdomains.
 */
export const getEcosystemName = () => {
  const ecosystemNames = window.ecosystemNames || {}
  const hostname = getEcosystemHostname()

  const domain = Object.keys(ecosystemNames).find(
    (candidate) =>
      candidate !== 'default' &&
      (hostname === candidate || hostname.endsWith(`.${candidate}`))
  )

  return (
    (domain && ecosystemNames[domain]) ||
    ecosystemNames.default ||
    FALLBACK_ECOSYSTEM
  )
}

export default getEcosystemName
